import { FlatAspect } from "@/models/HomePageSearchResponse";

// AJB: use slug here?
const DISTANCE_OPTIONS: FlatAspect[] = [
  {
    id: "50",
    label: "50km",
    level: 0,
  },
  {
    id: "100",
    label: "100km",
    level: 0,
  },
  {
    id: "250",
    label: "250km",
    level: 0,
  },
  {
    id: "500",
    label: "500km",
    level: 0,
  },
];

export default DISTANCE_OPTIONS;
